
<template>
  <v-alert
    app
    v-model="alert_logout"
    dense
    type="error"
    dismissible
  >
    <v-row class="px-1" align='center' justify='space-between'>

      <span>
        <!-- <strong>Bem vindo</strong>  -->
        Sua sessão será expírada em {{ alert_time }} minutos. Refaça o login.
      </span>

      <v-btn small color="white" class="black--text" @click="goToLogin">Relogar</v-btn>

    </v-row>
    <!-- <v-row align="center">
      <v-col class="grow">
        Nunc nonummy metus. Nunc interdum lacus sit amet orci. Nullam dictum felis eu pede mollis pretium. Cras id dui.
      </v-col>
      <v-col class="shrink">
        <v-btn>Take action</v-btn>
      </v-col>
    </v-row> -->
  </v-alert>

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';
import active_solution_mixin from '../../mixins/active_solution'
import Vue from 'vue';

export default {
  name: 'AutoLogout',
  mixins: [ active_solution_mixin ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],

      logout_timer: null,

      is_active: false,

      solution_logout_timer: 2 * 60 * 60 * 1000, // 2 hours

      checkAuthInterval: null,
      alert_logout: false,
      alert_time: null,
      checkAuthInterval: null,
      time_map: {
        ten: {
          status: false,
          closed: false,
          percentage: 0.1,
        },
        thirty: {
          status: false,
          closed: false,
          percentage: 0.3,
        },
        twenty: {
          status: false,
          closed: false,
          percentage: 0.5,
        },
      },
      login_time: null,
      expiry_time: null,
      already_checked: false,
      time_to_check: 1000 * 60 * 10, // 10 minutes
    }
  },
  mounted () {
    if (this.solutionID){
      this.checkSolutionSettingsForLogoutConfig();
      // this.ssoLogout();
      // this.firstCheckAndSetInterval();
    }
  },
  beforeDestroy () {
    this.is_active = false
    this.alert_logout = false;
    this.alert_time = null;
    this.removeEvents()
    this.eraseTimers()
  },
  methods: {
    setLoginTime() {
      this.login_time = localStorage.getItem('login_time');
      if (!this.login_time) {
        this.login_time = new Date();
        localStorage.setItem('login_time', this.login_time);
      } else {
        this.login_time = new Date(this.login_time)
      }
      // console.log('login_time', this.login_time);
    },
    setExpiryTime() {
      const split_caracter = this.auth_token.includes('|') ? '|' : ';';
      const splited_token = this.auth_token.split(split_caracter);
      const expiry = splited_token[splited_token.length - 1];
      this.expiry_time = new Date(expiry * 1000);
      // console.log('expiry_time', this.expiry_time);
    },
    setInterval() {
      this.checkAuthInterval = setInterval(() => {
        this.checkRemainingTime();
      }, this.time_to_check);
    },
    checkRemainingTime() {
      const current_time = new Date();
  
      const remaining_time = (this.expiry_time - current_time);

      const ten = remaining_time <= 10 * 60 * 1000;
      const twenty = remaining_time <= 20 * 60 * 1000;
      const thirty = remaining_time <= 30 * 60 * 1000;

      if ((!ten && !twenty && thirty && !this.time_map.thirty.closed)){
        this.alert_logout = true;
        this.alert_time = Math.floor((remaining_time / 1000 / 60)) + 1;
        this.time_map.thirty.status = true;
      } else if (twenty && !ten && !this.time_map.twenty.closed){
        this.alert_logout = true;
        this.alert_time = Math.floor((remaining_time / 1000 / 60)) + 1;
        this.time_map.twenty.status = true;
      } else if (ten && !this.time_map.ten.closed) {
        this.alert_logout = true;
        this.alert_time = Math.floor((remaining_time / 1000 / 60)) + 1;
        clearInterval(this.checkAuthInterval);
        this.time_to_check = 30000; // 1 minute
        this.setInterval();
        this.time_map.ten.status = true;
      }

      if (remaining_time <= 30000) {
        this.goToLogin(false);
      }
    },
    firstCheckAndSetInterval() {
      if (!this.auth_token) return;
      this.setLoginTime();
      this.setExpiryTime();
      this.setInterval();
      if (!this.already_checked) {
        this.checkRemainingTime();
        this.already_checked = true;
      }
    },
    async goToLogin(relog = true) {
      this.alert_logout = false;
      this.alert_time = null;
      localStorage.removeItem('login_time');

      this.time_map =  {
        ten: {
          status: false,
          closed: false,
          percentage: 0.1,
        },
        thirty: {
          status: false,
          closed: false,
          percentage: 0.3,
        },
        fifty: {
          status: false,
          closed: false,
          percentage: 0.5,
        },
      }
      clearInterval(this.checkAuthInterval);
      if (this.one_user.sso_enabled && relog) {
        try {
          const response = await Vue.axios.get(`/sso?email=${this.one_user.email}`);

          if (response.status == 200) {
            window.location.href = response.data.provider_url;

          } else {
            this.$router.push('/logout').catch(() => {});
          }
        } catch (error) {
          console.log(error);
          this.$router.push('/logout');
        }
      } else {
        this.$router.push('/logout');
      }

    },
    checkSolutionSettingsForLogoutConfig(){
      if (this.active_solution_settings.use_logout_timer){
        // alert('active_solution_settings.use_logout_timer')
        this.solution_logout_timer = this.active_solution_settings.logout_timer || 10 * 1000
        this.initEvents()
        this.setTimers()

        this.is_active = true
        this.addNotification({type: 'success', msg: 'Sessão iniciada'})
      } else {
        // alert('no timer')
        this.is_active = false
        this.eraseTimers()
        this.removeEvents()
      }
    },
    initEvents(){
      this.events.forEach(event => {
        window.addEventListener(event, () => this.resetTimers())
      });
    },
    removeEvents(){
      this.events.forEach(event => {
        window.removeEventListener(event, () => this.resetTimers())
      });
    },
    setTimers(){
      // console.log('setting timers');

      this.logout_timer = setTimeout(() => {
        this.logoutActions()
      }, this.solution_logout_timer) ;
    },
    resetTimers(){
      if (this.is_active){
        // console.log('active');
        this.eraseTimers()
        this.setTimers()
      }
    },
    eraseTimers(){
      clearTimeout(this.logout_timer)
      this.logout_timer = null
    },
    logoutActions(){
      if (this.$route.name != 'Login'){
        this.$router.push('/logout')
      }
      this.is_active = false
      this.removeEvents()
      this.eraseTimers()
    },
    ...mapActions({
      addNotification: 'Notification/add'
    })
  },
  computed: {
    auth_token() {
      return this.$auth.token();
      // return localStorage.getItem('auth_token_default')
    },
    ...mapState({
      one_user: state => state.User.oneUser,
    })
  },
  watch: {
    one_user(nv, ov) {
      console.log(nv)
      if (nv && nv.sso_enabled){
        this.firstCheckAndSetInterval();
      }
    },
    alert_logout(nv, ov) {
      if (nv == false) {
        Object.keys(this.time_map).map((key) => {
          if (this.time_map[key].status == true) {
            console.log("asd")
            this.time_map[key] = {...this.time_map[key], closed: true}
          }
        })
      }
    },
    solutionID(nv,ov) {
      if (nv){
        this.checkSolutionSettingsForLogoutConfig()
      } else if (nv == false){
    
      }
    },
    is_active(nv,ov) {
      console.log('is active changed: ', nv);
      if (nv){
    
      } else if (nv == false){
        this.eraseTimers()
        setTimeout(() => {
          this.eraseTimers()
        }, 300);
      }
    }
  },
}
</script>

<style scoped>

</style>